import { useState, useEffect } from "react";

const Spinner = () => {
	const [isVisible, setIsVisible] = useState(false);

	useEffect(() => {
		const timeout = setTimeout(() => {
			setIsVisible(true);
		}, 2000);
		return () => clearTimeout(timeout);
	}, []);

	return (
		<div className="flex flex-col gap-2 justify-center items-center">
			<svg className="animate-spin text-green-500 h-12 w-12" fill="none" viewBox="0 0 24 24">
				<circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
				<path
					className="opacity-75" fill="currentColor"
					d={`
					M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962
					7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z
				`}
				/>
			</svg>
			{isVisible && (
				<span className="text-xs uppercase animate-pulse text-center">
					This is taking longer than expected,<br />
					please be patient...
				</span>
			)}
		</div>
	);
};

export default Spinner;
